import styled from 'styled-components';
import { t } from 'localization/utils/t';

const TP = 'shared.components.Carousel';

interface IProgressIndicatorProps {
  activeIndex: number;
  itemListLength: number;
  className?: string;
}

export const ProgressIndicator = ({
  activeIndex,
  itemListLength,
  className = '',
}: IProgressIndicatorProps) => {
  return (
    <ProgressIndicator.Wrapper className={className} data-qa="progress_indicator">
      {t(`${TP}.progressIndicator`, '{activeIndex} of {itemListLength}', {
        activeIndex,
        itemListLength,
      })}
    </ProgressIndicator.Wrapper>
  );
};

ProgressIndicator.Wrapper = styled.div`
  margin-top: 8px;
`;
